import { SiloConfiguration } from '@silo/config-legacy';
import { AssetKeyLegacy, ChecksumAddress } from '@silo/types';
import { isUndefined } from '@silo/utils';
import { flow } from 'fp-ts/lib/function';

/**
 * If the asset is a convex wrapper in a curve LP silo, returns the address of
 * the curve LP token. Returns `null` otherwise.
 */
export const getCurveLpAssetAddress = (
  siloConfig: SiloConfiguration,
  assetKey: AssetKeyLegacy
): ChecksumAddress | null =>
  assetKey === 'base' && !isUndefined(siloConfig.curveLpTokenAddress_MUST_SYNCHRONIZE)
    ? siloConfig.curveLpTokenAddress_MUST_SYNCHRONIZE
    : null;

export const getIsCurveLpAsset = flow(getCurveLpAssetAddress, Boolean);

export const getIsCurveLpSilo = (siloConfig: SiloConfiguration): boolean =>
  !isUndefined(siloConfig.curveLpTokenAddress_MUST_SYNCHRONIZE);
